import React from "react";
import styled from "styled-components";
import settings from "@src/settings";
import HeaderBase from "../Header";
import SectionTitle from "../SectionTitle";
import VoiceItem from "../VoiceItem";
import JobInfo from "../JobInfo";
import ViewmoreBase from "../Viewmore";
import getGridHeight from "@src/utils/getGridHeight";
import { up, only, down } from "styled-breakpoints";
import trimLeading from "@src/utils/trimLeading";
import Intro from "@src/components/Intro";
import Float from "@src/components/Float";
import getGridWidth from "@src/utils/getGridWidth";

export const Header = styled(HeaderBase)`
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 9;
`;
export const Section = styled.section<{ backgroundColor?: string }>`
	position: relative;
	padding: ${getGridHeight({
			rows: 4,
			withTopGap: true,
			withBottomGap: true,
		})}px
		0 ${getGridHeight({ rows: 4, withBottomGap: true })}px;
	${(props) =>
		props.backgroundColor && `background-color: ${props.backgroundColor};`}
	${SectionTitle} + ${Intro},
	${SectionTitle} + ${JobInfo} {
		margin-top: ${getGridHeight({
			rows: 1,
			withTopGap: true,
			withBottomGap: true,
		})}px;
	}
	${JobInfo} + ${JobInfo} {
		margin-top: ${settings.baseGrid.lineGap}px;
	}
	& ${VoiceItem} + ${VoiceItem}, &#voice ${Float} + ${Float} {
		margin-top: ${getGridHeight({
			rows: 3,
			withTopGap: true,
			withBottomGap: true,
		})}px;
		${down("md")} {
			margin-top: ${getGridHeight({
				rows: 2,
				withTopGap: true,
				withBottomGap: true,
			})}px;
		}
	}
	${down("sm")} {
		padding: ${getGridHeight({
				rows: 2,
				withTopGap: true,
				withBottomGap: true,
			})}px
			0 ${getGridHeight({ rows: 2, withBottomGap: true })}px;
	}
	${down("xs")} {
		${SectionTitle} + ${Intro},
	${SectionTitle} + ${JobInfo} {
			margin-top: ${getGridHeight({
				rows: 1,
				withBottomGap: true,
			})}px;
		}
	}
`;

export const Lead = styled.p`
	font-weight: 400;
	font-family: ${settings.font.jp};
	color: ${settings.color.main};
	letter-spacing: 2.2857px;
	white-space: pre-line;
	${trimLeading({ fontSize: 16, lineHeight: 16 * 2.25 })}
	${SectionTitle} + & {
		margin-top: ${5 + getGridHeight({ rows: 1, withBottomGap: true })}px;
	}
	${down("xs")} {
		${trimLeading({ fontSize: 16, lineHeight: 28, font: "montserrat" })}
	}
`;

export const Viewmore = styled(ViewmoreBase)`
	${Lead} + & {
		margin-top: ${getGridHeight({ rows: 2 })}px;
	}
	${down("xs")} {
		${Lead} + & {
			margin-top: ${getGridHeight({
				rows: 1,
				withTopGap: true,
				withBottomGap: true,
			})}px;
		}
	}
`;
export const SectionIntro = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: ${getGridHeight({
		rows: 2,
		withTopGap: true,
		withBottomGap: true,
	})}px;
	&#voice > ${Lead} {
		text-align: center;
		${down("md")} {
			text-align: left;
		}
	}
	${down("md")} {
	}
`;

export const Container = styled.div<{ windowW: number | null }>`
	width: ${settings.contentWidth.xl}px;
	margin: 0 auto;
	${up("xxl")} {
		width: ${settings.contentWidth.xxl}px;
	}
	${only("xl")} {
		width: ${settings.contentWidth.xl}px;
	}
	${only("lg")} {
		width: ${settings.contentWidth.lg}px;
	}
	${only("md")} {
		width: ${settings.contentWidth.md}px;
	}
	${only("sm")} {
		width: ${settings.contentWidth.sm}px;
	}
	${down("xs")} {
		width: ${settings.contentWidth.xs}px;
		width: ${(props) =>
			getGridWidth({ windowW: props.windowW }) -
			settings.baseGrid.fontSize * 4}px;
	}
`;
